import { useState } from "react"
import { toast } from 'react-hot-toast';
import Loader from "../../Components/Common/Loader";
import SystemModal from "../../Components/Common/SystemModal";
import ajaxSchool from "../../util/remote/ajaxSchool";


const TermlyFeeBoothUnlock=(props)=>{

    const [loading, setLoading] = useState(false)

    const handleUpdate = async(e) =>{
        e.preventDefault()
        setLoading(true)
        const server_response = await ajaxSchool.termlyFeeUnlock(props.schoolID);
        setLoading(false);
        if(server_response.status==="OK"){
            toast.success(server_response.message);
            props.g()
        }
        else{
            toast.error(server_response.message); 
        } 
    }
    

    const RenderFooter=(controls)=>{

        if(loading){
            return <Loader/>
        }else{

            return <> 
                    <button className="btn-fill-md text-light bg-martini shadow-martini" type="button" onClick={controls.close}>Close</button>
                    <button 
                        type="button" 
                        className={`btn-fill-md text-light bg-dodger-blue`} 
                        onClick={handleUpdate}>Confirm<i class="fas fa-check mg-l-15"></i></button>
                    </>
        }
    }

    return(
        <SystemModal
            title="Termly Fee Unlock"
            id="model-unlock-termly-fee"
            size="md"
            footer={RenderFooter}
        >

        <div className="row">
        <div className="bg-white">
                <div className="alert text-center">
                    <i className="fe fe-alert-circle fs-50 text-warning" style={{fontSize:"50px"}}></i>
                    <h3 className="mt-2 mb-1">Are you sure you want to unblock Buzztime features according to termly fee status?</h3>
                    <p className="mb-3 mb-3 tx-inverse">Student will access all services regardless of one's termly fee status.</p>
                </div>
            </div>
        </div>
       
        </SystemModal>
    )
}

export default TermlyFeeBoothUnlock
